<template>
  <v-select
    :items="items"
    :label="label"
    dense
    @input="$emit('input', $event)"
  />
</template>

<script>
export default {
  name: 'Select',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
  },
};
</script>